import jsSHA from 'jssha';

export default v => {
  const objSHA = new jsSHA('SHA3-256', 'TEXT');
  objSHA.update(v);
  objSHA.update(process.env.ENCRYPTION_CONCATENATION_STRING);
  return objSHA.getHash('HEX');
};

export const sha1 = v => {
  const objSHA = new jsSHA('SHA-1', 'TEXT');
  objSHA.update(v);
  return objSHA.getHash('HEX');
};



// WEBPACK FOOTER //
// ./src/services/encrypt.js